<div class="sharesHeaders__activity" ppTooltip [ppTitle]="ppDisabled ? disabledTooltipText : ''">
  <pp-toggle
    [ppChecked]="viewPermission"
    (ppAction)="changeViewPermission()"
    ppStyle="blue"
    [ppDisabled]="ppDisabled"
  ></pp-toggle>
</div>
